import React, { Component } from "react";
import Avatar from "../../avatar/Avatar";
import moment from "moment";

require("./genericAction.scss");

export default class GenericActionView extends Component {
  render() {
    return <div className="join-message" style={{ color: this.props.color, justifyContent: this.props.textAlign || "unset" }}>
        <Avatar image={this.props.avatar} color={this.props.color} nickname={this.props.nickname} />
        <div className="vertical-items">
          <div className="timestamp">
            {moment(this.props.timestamp).format("h:mm a")}
          </div>
          <div>{this.props.text}</div>
        </div>
      </div>;
  }
}


// WEBPACK FOOTER //
// ./src/views/messages/modern/GenericAction.jsx